import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { List, ListItem, Link } from '@material-ui/core';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import clsx from 'clsx';

import useStyles from './useStyles';

const PageNav = ({ items, light }) => {
  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

  const classes = useStyles({ light });
  const { t } = useTranslation();

  const handleClick = (href, offsetY = 0) => {
    gsap.to(window, { duration: 1, scrollTo: { y: href, offsetY, autoKill: true } });
  };

  const [active, setActive] = useState('');

  useEffect(() => {
    const listOfAnimation = items.reduce((acc, item) => {
      const { id, href } = item;
      const animation = gsap.to(`#${id}`, {
        scrollTrigger: {
          trigger: href,
          start: 'top 45%',
          end: '98% center',
          onEnter: () => setActive(id),
          onEnterBack: () => setActive(id),
        },
      });
      return [...acc, animation];
    }, []);
    return () => listOfAnimation.forEach(item => item.scrollTrigger.disable(false));
  }, []);

  return (
    <List className={classes.list}>
      {items.map(({ id, label, href, offsetY }) => (
        <ListItem key={id} className={classes.item}>
          <Link
            id={id}
            component="button"
            className={clsx(classes.link, { [classes.active]: id === active })}
            onClick={() => handleClick(href, offsetY)}
          >
            {t(label)}
          </Link>
        </ListItem>
      ))}
    </List>
  );
};

PageNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  light: PropTypes.bool,
};

PageNav.defaultProps = {
  light: false,
};

export default PageNav;



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Description/components/PageNav/PageNav.js